import store from 'store'
// redux imports
import { createSystemNotification } from 'redux/Notifications'
import { addSession, holdActiveSession } from 'redux/Sessions'
import { dialerReady, setIsShown } from 'redux/Config'
import { userAgentRegistrationFailed } from 'redux/Sip'
// module imports
import eventLogger from 'modules/Logger'
import { CSv3parkedFromHeaders } from 'modules/ParkingSlot'
import { isCSV3 } from 'modules/Helpers'
import { dialerIsConnected } from 'modules/GlobalEvents/EventDispatchers'
// constant imports
import sessions from 'constants/Sessions'
import { fetchAllContacts } from 'redux/Contacts'
// SIP imports
import { setSessionListeners } from './Sessions'
import { parkCall } from './Helpers'

// https://jssip.net/documentation/3.4.x/api/ua

const events = {
  /**
   * WebSocket connection events
   */
  connecting: async (event) => {
    eventLogger.info('connecting', event)
    dialerIsConnected(false)
  },
  connected: async (event) => {
    eventLogger.info('connected', event)
    dialerIsConnected(true)
  },
  disconnected: async (event) => {
    eventLogger.info('disconnected', event)
    dialerIsConnected(false)
  },

  /*
   * SIP registration events
   */
  registered: async (event) => {
    eventLogger.info('registered', event)
    store.dispatch(dialerReady())
  },
  unregistered: async (event) => {
    eventLogger.info('unregistered', event)
  },
  registrationFailed: async (event) => {
    eventLogger.error('registration_failed', event)
    store.dispatch(userAgentRegistrationFailed())
  },

  // registrationExpiring: async (event) => {
  //   logInfo('registration_expiring', event)
  // }

  /*
   * New incoming or outgoing call event
   */
  newRTCSession: async (event) => {
    eventLogger.info('new_rtc_session', event)

    // fetch all contacts before adding session
    store.dispatch(fetchAllContacts())

    const { session, request } = event

    // handle outgoing
    if (session.direction === sessions.direction.outgoing) {
      store.dispatch(holdActiveSession())
    }

    // create session "ID"
    const id = store.getState().sessions.list.length
    // add session to sessionList
    store.dispatch(addSession(session, id, request))
    // set session listeners
    setSessionListeners(session, id, store.getState)

    // handle incoming
    if (session.direction === sessions.direction.incoming) {
      store.dispatch(createSystemNotification(id))

      const { modeFloat, isShown } = store.getState().config
      if (!modeFloat && isShown) {
        store.dispatch(setIsShown(false))
      }
    }
  },

  /**
   * New incoming or outgoing IM message event
   */
  newMessage: async (event) => {
    eventLogger.info('new_message', event)
    if (isCSV3()) {
      const {
        request: { headers },
      } = event
      const park = CSv3parkedFromHeaders(headers)

      if (!park) return

      const { list } = store.getState().sessions
      const id = list.findIndex((session) => {
        if (!session || !session.parking) {
          return false
        }
        const { extension, phone } = session.participant
        const numberToDial = session.incoming
          ? session.participant.callDetails.from.source
          : session.participant.numberToDial

        const replacerFn = (c) => String(c || '').replace(/\D/g, '')
        const parkChecks = [park.rawSlot, park.phone].map(replacerFn)
        const sessionChecks = [numberToDial, extension, phone].map(replacerFn)

        return parkChecks.some((c) => sessionChecks.includes(c))
      })

      if (id < 0) return

      const session = list[id]
      parkCall(id, park.slot, session?.session?.isEnded())
    }
  },
  sipEvent: async (event) => {
    eventLogger.info('sip_event', event)
  },
}

export const setEventListeners = (userAgent) => {
  Object.keys(events).forEach((event) => {
    userAgent.on(event, events[event])
  })
}
